/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_CpfInputs */

const en_clients_field_cpf = /** @type {(inputs: Clients_Field_CpfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CPF`)
};

const pt_br2_clients_field_cpf = /** @type {(inputs: Clients_Field_CpfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CPF`)
};

/**
* | output |
* | --- |
* | "CPF" |
*
* @param {Clients_Field_CpfInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_cpf = /** @type {((inputs?: Clients_Field_CpfInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_CpfInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_cpf(inputs)
	return pt_br2_clients_field_cpf(inputs)
});